/**
 * Removes empty string, arrays, and objects, from a given input.
 * Use this to clean up Formly forms- it removes empty fields from the payload.
 *
 **/
export const removeEmptyItems = (item?: any): any => {
  const isEmpty = v => v === null || v === undefined;

  // Arrays
  if (Array.isArray(item)) {
    const cleaned = item
      .map(v => removeEmptyItems(v))
      .filter(v => v !== undefined && !(typeof v === 'object' && Object.keys(v).length === 0));

    return cleaned.length > 0 ? cleaned : undefined;
  }

  // Objects
  if (typeof item === 'object' && item !== null) {
    const result: any = {};

    // Contacts (purposefully send an all-empty payload to delete a contact; otherwise, preserve its structure)
    for (const [key, value] of Object.entries(item)) {
      if (key === 'contacts') {
        if (!Array.isArray(value) || value.length === 0) {
          result.contacts = [{phone_number: '', email: '', name: ''}];
        } else {
          result.contacts = value.map(contact => {
            const cleaned = removeEmptyItems(contact) || {};
            const fields = ['name', 'email', 'phone_number', 'notes'];
            const allEmpty = fields.every(f => isEmpty(cleaned[f]));

            if (allEmpty) {
              return {phone_number: '', email: '', name: ''};
            } else {
              return cleaned;
            }
          });
        }
      } else {
        const cleaned = removeEmptyItems(value);
        if (cleaned !== undefined && !(typeof cleaned === 'object' && Object.keys(cleaned).length === 0)) {
          result[key] = cleaned;
        }
      }
    }

    if (Object.keys(result).length === 0) return undefined;
    return result;
  }

  // Single value
  if (isEmpty(item)) return undefined;
  return item;
};
